import React from "react";
import Link from "next/link";
import classNames from "classnames";
import { themeValue } from "@kursk/themes";
import { BelDownArrowIcon } from "@kursk/components/ui/icons.bel";
import { ArrowRightIcon } from "@kursk/components/ui/icons";
import { useOrientations } from "@common/hooks/useOrientation";
import styles from './SectionLink.module.scss';

export const SectionLink = ({ title, goTo, pushkinPage = false }) => {

  const orientation = useOrientations();
  const actualTitle = orientation === 'mobile' && title ? 'Все' : title;

  return (<Link href={goTo} passHref>
    <a className={styles.goToHref}>
      {actualTitle &&
          <button className={classNames(styles.button, pushkinPage && styles.pushkinButton)}>
            <div className={styles.text}>{actualTitle}</div>
            {themeValue({
              bel: <BelDownArrowIcon/>,
              default: <ArrowRightIcon/>,
            })}
          </button>}
    </a>
  </Link>);
}
